import type { ReactNode } from 'react';

type Props = {
  title?: string;
  description?: string;
  action?: ReactNode;
  icon?: ReactNode;
};

export function EmptyState({
  title = 'Nothing here yet',
  description,
  action,
  icon,
}: Props) {
  return (
    <div className="flex flex-col items-center text-center gap-3 py-2">
      {icon ? (
        <div className="h-14 w-14 rounded-2xl bg-accent-bg flex items-center justify-center text-accent">
          {icon}
        </div>
      ) : (
        <p className="text-[80px] font-black text-text/5 leading-none select-none">0</p>
      )}
      <div className={icon ? '' : '-mt-4'}>
        <p className="text-sm font-black text-text uppercase tracking-widest">{title}</p>
        {description && <p className="text-sm text-muted mt-1">{description}</p>}
      </div>
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}
